import IImageUrls from "../models/IImageUrls.model";

export default class ConfigService {
	public imageUrls: IImageUrls = {
		visaIconUrl: "",
		mastercardIconUrl: "",
		americanExpressIconUrl: "",
		googlePayIconUrl: "",
		applePayIconUrl: "",
		paypalIconUrl: "",
		klarnaIconUrl: "",
		clearpayIconUrl: "",
		paymentMethodIconCount: null,
		useFinanceAccordion: false
	};

	constructor() {
		const imageUrlsElement = document.querySelector(".js-image-urls");
		if (imageUrlsElement) {
			const imageUrls = JSON.parse(imageUrlsElement.innerHTML);
			this.imageUrls = imageUrls;
		}
	}
}
